module.exports = __webpack_public_path__ + "ea4f1028aa8fdffa2d0e1de04e0ad551.png";